export default "__VITE_ASSET__CQiXZr27__"